<template>
  <main>
    <div class="py-5 mx-auto sm:px-6 lg:px-8">
      <div class="bg-white shadow overflow-hidden sm:rounded-md mt-2 p-8">
        <form @submit.prevent="submit">
          <div>
            <div class="border-gray-200">
              <div>
                <h3 class="text-lg leading-6 font-medium text-gray-900">
                  Profil
                </h3>
                <p class="mt-1 max-w-2xl text-sm leading-5 text-gray-500">
                  Vous pouvez ici modifier les informations relatives à votre
                  compte.
                </p>
              </div>
              <div class="mt-6 sm:mt-5">
                <div
                  class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                >
                  <label
                    for="first_name"
                    class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2"
                  >
                    Prénom
                  </label>
                  <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <div class="max-w-xs rounded-md shadow-sm">
                      <input
                        v-model="editUser.first_name"
                        id="first_name"
                        class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="mt-6 sm:mt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                >
                  <label
                    for="last_name"
                    class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2"
                  >
                    Nom
                  </label>
                  <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <div class="max-w-xs rounded-md shadow-sm">
                      <input
                        v-model="editUser.last_name"
                        id="last_name"
                        class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="mt-6 sm:mt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-gray-200 sm:pt-5"
                >
                  <label
                    for="email"
                    class="block text-sm font-medium leading-5 text-gray-700 sm:mt-px sm:pt-2"
                  >
                    Adresse email
                  </label>
                  <div class="mt-1 sm:mt-0 sm:col-span-2">
                    <div class="max-w-lg rounded-md shadow-sm">
                      <input
                        v-model="editUser.email"
                        id="email"
                        type="email"
                        class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                      />
                    </div>
                  </div>
                </div>

                <div
                  class="mt-6 sm:mt-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:items-center sm:border-t sm:border-gray-200 sm:pt-5"
                >
                  <label
                    for="photo"
                    class="block text-sm leading-5 font-medium text-gray-700"
                  >
                    Photo
                  </label>
                  <div class="mt-2 sm:mt-0 sm:col-span-2">
                    <div v-if="avatar.open">
                      <my-upload
                        field="img"
                        @crop-success="cropSuccess"
                        v-model="avatar.open"
                        :width="150"
                        :height="150"
                        lang-type="fr"
                        img-format="png"
                      ></my-upload>
                    </div>
                    <div class="flex items-center">
                        <img
                        class="h-12 w-12 rounded-full"
                        v-if="avatar.base64"
                        :src="avatar.base64"
                        />
                      <span
                      v-else
                        class="h-12 w-12 rounded-full overflow-hidden bg-gray-100"
                      >
                        <svg
                          class="h-full w-full text-gray-300"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z"
                          />
                        </svg>
                      </span>
                      <span class="ml-5 rounded-md shadow-sm">
                        <button
                          @click="openUpload"
                          type="button"
                          class="py-2 px-3 border border-gray-300 rounded-md text-sm leading-4 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
                        >
                          Change
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-8 border-t border-gray-200 pt-5">
            <div class="flex justify-end">
              <span class="ml-3 inline-flex rounded-md shadow-sm">
                <button
                  type="submit"
                  class="inline-flex justify-center py-2 px-4 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition duration-150 ease-in-out"
                >
                  Enregistrer
                </button>
              </span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from "vuex";
import MyUpload from "vue-image-crop-upload";

export default {
    components: { MyUpload },
    data() {
        return {
            editUser: null,
            avatar: {
                open: false,
                base64: null
            }
        };
    },
    computed: {
        ...mapState("auth", ["user"])
    },
    methods: {
        submit() {
            console.log("submit");
        },
        cropSuccess(avatar) {
            this.avatar.base64 = avatar;
        },
        openUpload() {
            this.avatar.open = true;
        }
    },
    watch: {
        user() {
            this.editUser = Object.assign({}, this.user);
        }
    },
    created() {
        this.editUser = Object.assign({}, this.user);
    }
};
</script>
